import { Layout } from "antd";
import React from "react";
import styled from "@emotion/styled";

const Body = styled(Layout.Content)`
  padding: 10px 24px;
`;

const PageBody: React.SFC = ({ children }) => <Body>{children}</Body>;

export default PageBody;
